import { Component } from '@angular/core';

@Component({
  selector: 'app-catalog-admin',
  imports: [],
  templateUrl: './catalog-admin.component.html',
  styles: ``
})
export class CatalogAdminComponent {
  
}
